var LEFT_ADDON_OPTIONS = {
  LockUnlocked: 'LockUnlocked',
  LockLocked: 'LockLocked'
};
var RIGHT_ADDON_OPTIONS = {
  VisibleView: 'VisibleView',
  InvisibleHide: 'InvisibleHide'
};

export { LEFT_ADDON_OPTIONS, RIGHT_ADDON_OPTIONS };
//# sourceMappingURL=options.js.map
